module.exports = __webpack_public_path__ + "static/media/education-object-0-0-1.8c0aadad.svg";